import { Action, IOWidget, mk_pair, Pair } from 'widgets-for-react'
import React from 'react'

// import { CtaBlock, CtaBlockProps, CtaBlockStyle } from '../../public_site/blocks/custom_blocks/widgets/ctaBlock'
import { DownloadBlock, DownloadBlockProps, DownloadBlockStyle } from './widgets/downloadBlock.gen'
import { ExpandBlock, ExpandBlockProps, ExpandBlockStyle } from './widgets/expandBlock.gen'
import {
  FeaturedContentBlockStyle,
  FeaturedContentComponent,
  FeaturedContentBlockProps
} from './widgets/featuredContentBlock.gen'
import { BlockData, CMSState } from './types.gen'
import { IframeBlockProps, IframeBlockStyle, IframeBlock } from './widgets/iframeBlock.gen'
import { jsxToWidget } from './utils.gen'
import { LinkBlock, LinkBlockProps, LinkBlockStyle } from './widgets/linkBlock.gen'
import { LinkGridBlock, LinkGridBlockProps, LinkGridBlockStyle } from './widgets/linkGridBlock.gen'
import { MediaBlockProps, MediaBlockStyle, MediaBlock } from './widgets/mediaBlock.gen'
import { QuoteBlockProps, QuoteBlockStyle, QuoteBlock } from './widgets/quoteBlock.gen'
import { TextBlockProps, TextBlockStyle, TextBlock } from './widgets/textBlock.gen'
import { CtaBlockProps, CtaBlockStyle, CtaBlock } from './widgets/ctaBlock.gen'

export type BlocksRenderer<customBlockData, extra_images, customPageData> = {
  featuredContentComponent: (
    itemsOptions: Array<
      Pair<
        FeaturedContentBlockProps<customBlockData, extra_images>,
        { style?: FeaturedContentBlockStyle; key?: string }
      >
    >
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  expandBlock: (
    props: ExpandBlockProps,
    options?: { style?: ExpandBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  mediaBlock: (
    props: MediaBlockProps<extra_images>,
    options?: { style?: MediaBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  linkGridBlock: (
    props: LinkGridBlockProps<extra_images>,
    options?: { style?: LinkGridBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  linkBlock: (
    props: LinkBlockProps,
    options?: { style?: LinkBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  downloadBlock: (
    props: DownloadBlockProps,
    options?: { style?: DownloadBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  ctaBlock: (
    props: CtaBlockProps,
    options?: { style?: CtaBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  textBlock: (
    props: TextBlockProps<customBlockData, extra_images>,
    options?: { style?: TextBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  iframeBlock: (
    props: IframeBlockProps,
    options?: { style?: IframeBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
  quoteBlock: (
    props: QuoteBlockProps<extra_images>,
    options?: { style?: QuoteBlockStyle; key?: string }
  ) => IOWidget<CMSState<customBlockData, extra_images, customPageData>, Action<CMSState<customBlockData, extra_images, customPageData>>>
}

export let getMockedBlockRenderer = <customBlockData, extra_images, customPageData>(): BlocksRenderer<customBlockData, extra_images, customPageData> => {
  return {
    featuredContentComponent: FeaturedContentComponent,
    expandBlock: ExpandBlock,
    mediaBlock: MediaBlock,
    linkGridBlock: LinkGridBlock,
    linkBlock: LinkBlock,
    downloadBlock: DownloadBlock,
    ctaBlock: CtaBlock,
    textBlock: TextBlock,
    iframeBlock: IframeBlock,
    quoteBlock: QuoteBlock
  }
}

export function renderBlock<CustomBlockData extends { kind: CustomBlockData['kind'] }, custom_images, customPageData>(
  block: BlockData<CustomBlockData, custom_images>,
  block_renderer: BlocksRenderer<CustomBlockData, custom_images, customPageData>,
  key?: string
): IOWidget<CMSState<CustomBlockData, custom_images, customPageData>, Action<CMSState<CustomBlockData, custom_images, customPageData>>> {
  return s0 =>
    block.kind === 'featuredContentBlock'
      ? block_renderer.featuredContentComponent(block.value.map(e => mk_pair(e.fst, { style: e.snd, key })))(s0)
      : block.kind === 'textBlock'
      ? block_renderer.textBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'ctaBlock'
      ? block_renderer.ctaBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'downloadBlock'
      ? block_renderer.downloadBlock(block.value.fst, { key, style: block.value.snd })(s0)
      : block.kind === 'linkBlock'
      ? block_renderer.linkBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'linkGridBlock'
      ? block_renderer.linkGridBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'mediaBlock'
      ? block_renderer.mediaBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'expandBlock'
      ? block_renderer.expandBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'quoteBlock'
      ? block_renderer.quoteBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : block.kind === 'iframeBlock'
      ? block_renderer.iframeBlock(block.value.fst, { style: block.value.snd, key })(s0)
      : jsxToWidget<Action<CMSState<CustomBlockData, custom_images, customPageData>>>(<div key={key}>Block not found</div>).never()
}
